module.exports = __webpack_public_path__ + "static/media/object-colony-01.b92c8e0a.svg";